export const createDataPoint = (time = Date.now(), magnitude = 1000, offset = 0) => {
  return [time + offset * magnitude, Math.round(Math.random() * 100 * 2) / 2];
};

export const createRandomData = (time: number, magnitude: number, points = 100) => {
  const data = [];
  let i = points * -1 + 1;
  for (i; i <= 0; i++) {
    data.push(createDataPoint(time, magnitude, i));
  }
  return data;
};

export const shortText = (text: string, length: number, appender?: string): string => {
  if (!text) return text;
  let textLength = text.length;
  if (textLength > length) return text.substring(0, length) + (appender ?? '...');
  return text;
};

export const chartTooltipWrapper = (children: string, className?: string): string => {
  let html = `<div class="${className}" 
        style="dislay:flex;
        flex-direction:column;
        padding: 5px 10px;
        background: bg-background;
        color: text-text;
        border-radius: 10px;
        ">${children}</div>`;
  return html;
};

export const commaThousondSeperator = (
  input: number | null | undefined,
  commo = ',',
  dot = '/'
): string => {
  const t = typeof input;
  if (t === null || t === undefined) return '-';
  let str = (input ?? '').toString();
  let arr = str.split('.');
  return (
    arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, commo) + (arr.length === 2 ? `${dot}${arr[1]}` : '')
  );
};

export const createLegend = (
  name: string,
  color: string,
  shape: 'square' | 'circle' | 'bullet' | string
) => {
  let shapeHtml = '';
  const shapeStyle = `display:inline-block;width:6px;height:6px;background-color:${color};`;
  switch (shape) {
    case 'square':
      shapeHtml = `<span style="${shapeStyle}"></span>`;
      break;
    case 'bullet':
      shapeHtml = `<span style="border-radius:50%;${shapeStyle}border:solid 2px ${color};background-color:transparent;"></span>`;
      break;
    case 'circle':
      shapeHtml = `<span style="border-radius:50%;${shapeStyle}"></span>`;
      break;
    default:
      shapeHtml = '';
      break;
  }
  return `<span style="display:inline-flex;gap:0.25rem;direction:rtl;align-items: center;" class="custom-legend">
        ${shapeHtml}
        <span style="color:${color};" class="name">${name}</span>
        </span>`;
};

export function formatDecimalNumber(input: number, dot = '/', decimalLength = 2): string {
  if (input % 1 == 0) return input.toString().replace('.', dot);
  return input.toFixed(decimalLength).toString().replace('.', dot);
}

export const formatNumber = (num: number, decimalLength = 1, dot = '/'): string => {
  let isNegative = num < 0;
  num = Math.abs(num as number);
  let result: string = num.toString();
  let suffix = '';
  const lessThanThousond = 999,
    thousond = 1000,
    million = 1000000,
    Billion = 1000000000;
  // trillion = 1000000000000;

  if (num > lessThanThousond && num <= million) {
    result = (num / thousond).toFixed(decimalLength);
    suffix = 'K';
  } else if (num > million && num <= Billion) {
    result = (num / 1000000).toFixed(decimalLength);
    suffix = 'M';
  } else if (num > Billion) {
    result = (num / Billion).toFixed(decimalLength);
    suffix = 'B';
  }
  // else if (num >= trillion) {
  //   result = (num / trillion).toFixed(decimalLength);
  //   suffix = "T";
  // }
  let output = parseFloat(result);
  return `${isNegative ? '-' : ''}${output}${suffix}`.replace('.', dot);
};

export function isNan(value: number | null | undefined | string) {
  return Number.isNaN(Number(value));
}
